import React from 'react';
import styles from './Logo.module.scss';
import { Link } from 'react-router-dom';


const Logo = () => {
    return (
        <Link className={styles.logoLink} to='/'>
            <div className={styles.logo}>
                    <div className={styles.borderTop} />
                    <div className={styles.textContainer}>
                        <h2>Kамена & Христо</h2>
                    </div>
                    <div className={styles.borderBottom} />
            </div>
        </Link>
    )
}

export default Logo;